// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  max-width: 1200px;
  width: 95%;
  max-height: calc(100vh - 40px); /* Allow expansion but leave margin for viewport */
  min-height: 50vh; /* Ensure minimum usable height */
  overflow-y: auto; /* Show scrollbar only if content exceeds viewport */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  background-color: #f8f9fa;
  border-radius: 8px 8px 0 0;
}

.modal-header h2 {
  margin: 0;
  color: #333;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-button:hover {
  color: #000;
}

.modal-body {
  padding: 20px;
  overflow: hidden;
}

.document-details {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.detail-row {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.detail-row label {
  font-weight: bold;
  color: #555;
  font-size: 14px;
}

.detail-row span {
  color: #333;
  padding: 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #dee2e6;
}

.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  min-width: 60px; /* Ensure consistent minimum width */
  text-align: center; /* Center text within badge */
}

.status-badge.status-approved {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.status-badge.status-processing {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

.status-badge.status-failed {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.status-badge.status-rejected {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.status-badge.status-review_required {
  background-color: #ffeaa7;
  color: #856404;
  border: 1px solid #ffdd7b;
}

.error-message {
  color: #721c24;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
}

/* Two-column layout for document preview and information */
.document-content-layout {
  display: flex !important;
  flex-direction: row !important;
  gap: 20px;
  height: 70vh;
  min-height: 500px;
}

.document-preview-section {
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #dee2e6;
  padding-right: 20px;
  min-width: 0;
  background-color: #f0f8ff; /* Light blue for debugging */
}

.document-preview-section h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: bold;
}

.document-preview-iframe {
  width: 100%;
  flex: 1 1;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background-color: #f8f9fa;
}

.no-preview-message {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  color: #666;
  font-style: italic;
}

.document-info-section {
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  min-width: 0;
  background-color: #f0fff0; /* Light green for debugging */
}

.document-info-section h3 {
  margin: 0 0 15px 0;
  color: #333;
  font-size: 16px;
  font-weight: bold;
}

/* Responsive design for smaller screens */
@media (max-width: 600px) {
  .document-content-layout {
    flex-direction: column !important;
    height: auto;
  }

  .document-preview-section {
    border-right: none;
    border-bottom: 1px solid #dee2e6;
    padding-right: 0;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }

  .document-preview-iframe {
    height: 400px;
  }

  .modal-content {
    max-width: 95%;
    width: 95%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/DocumentDetails.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,8BAA8B,EAAE,kDAAkD;EAClF,gBAAgB,EAAE,iCAAiC;EACnD,gBAAgB,EAAE,oDAAoD;EACtE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,eAAe,EAAE,oCAAoC;EACrD,kBAAkB,EAAE,6BAA6B;AACnD;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,yBAAyB,EAAE,6BAA6B;AAC1D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA,0CAA0C;AAC1C;EACE;IACE,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  border-radius: 8px;\n  max-width: 1200px;\n  width: 95%;\n  max-height: calc(100vh - 40px); /* Allow expansion but leave margin for viewport */\n  min-height: 50vh; /* Ensure minimum usable height */\n  overflow-y: auto; /* Show scrollbar only if content exceeds viewport */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n  background-color: #f8f9fa;\n  border-radius: 8px 8px 0 0;\n}\n\n.modal-header h2 {\n  margin: 0;\n  color: #333;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: #666;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.close-button:hover {\n  color: #000;\n}\n\n.modal-body {\n  padding: 20px;\n  overflow: hidden;\n}\n\n.document-details {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.detail-row {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.detail-row label {\n  font-weight: bold;\n  color: #555;\n  font-size: 14px;\n}\n\n.detail-row span {\n  color: #333;\n  padding: 8px;\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  border: 1px solid #dee2e6;\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  min-width: 60px; /* Ensure consistent minimum width */\n  text-align: center; /* Center text within badge */\n}\n\n.status-badge.status-approved {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.status-badge.status-processing {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #ffeaa7;\n}\n\n.status-badge.status-failed {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.status-badge.status-rejected {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}\n\n.status-badge.status-review_required {\n  background-color: #ffeaa7;\n  color: #856404;\n  border: 1px solid #ffdd7b;\n}\n\n.error-message {\n  color: #721c24;\n  background-color: #f8d7da;\n  border: 1px solid #f5c6cb;\n}\n\n/* Two-column layout for document preview and information */\n.document-content-layout {\n  display: flex !important;\n  flex-direction: row !important;\n  gap: 20px;\n  height: 70vh;\n  min-height: 500px;\n}\n\n.document-preview-section {\n  flex: 1 1 50%;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #dee2e6;\n  padding-right: 20px;\n  min-width: 0;\n  background-color: #f0f8ff; /* Light blue for debugging */\n}\n\n.document-preview-section h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.document-preview-iframe {\n  width: 100%;\n  flex: 1;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background-color: #f8f9fa;\n}\n\n.no-preview-message {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  color: #666;\n  font-style: italic;\n}\n\n.document-info-section {\n  flex: 1 1 50%;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  min-width: 0;\n  background-color: #f0fff0; /* Light green for debugging */\n}\n\n.document-info-section h3 {\n  margin: 0 0 15px 0;\n  color: #333;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n/* Responsive design for smaller screens */\n@media (max-width: 600px) {\n  .document-content-layout {\n    flex-direction: column !important;\n    height: auto;\n  }\n\n  .document-preview-section {\n    border-right: none;\n    border-bottom: 1px solid #dee2e6;\n    padding-right: 0;\n    padding-bottom: 20px;\n    margin-bottom: 20px;\n  }\n\n  .document-preview-iframe {\n    height: 400px;\n  }\n\n  .modal-content {\n    max-width: 95%;\n    width: 95%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
